import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/hotels/Detail/index.jsx");
